/* «Elige tu móvil» fuera de la ficha (snippets/model-finder.liquid): pestañas de marca, buscador y
   más vendidos. Cada modelo es un enlace a su ficha, así que elegir nunca toca el carrito. En modo
   «filter» (colecciones) el enlace no navega: avisa con el evento finder:pick y collection.js
   cambia las tarjetas. En la home, si el modelo está en más de una funda (data-finder-dests), antes
   de ir se elige la funda en el mismo panel ([data-finder-choose]).
   ponytail: misma lógica de marcas y buscador que ModelPicker (product.js); unificarlas si se toca la ficha. */
(() => {
  const searchable = (text) => String(text).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '');

  document.querySelectorAll('[data-finder]:not([data-finder-ready])').forEach((root) => {
    root.dataset.finderReady = '';
    const search = root.querySelector('[data-finder-search]');
    const all = root.querySelector('[data-finder-all]');
    const choose = root.querySelector('[data-finder-choose]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let brand = root.dataset.finderStart;
    let opener = null;
    const extremeData = root.querySelector('[data-finder-extreme]');
    const extreme = extremeData ? JSON.parse(extremeData.textContent).models : {};

    const render = () => {
      const query = searchable(search.value);
      root.querySelectorAll('[data-finder-brand]').forEach((button) => {
        button.setAttribute('aria-pressed', String(!query && button.dataset.finderBrand === brand));
      });
      const best = root.querySelector('[data-finder-best]');
      if (best) {
        let chips = 0;
        best.querySelectorAll('[data-finder-model]').forEach((chip) => {
          chip.hidden = Boolean(query) || chip.dataset.brand !== brand;
          if (!chip.hidden) chips += 1;
        });
        best.hidden = chips === 0;
      }
      let shown = 0;
      root.querySelectorAll('[data-finder-panel]').forEach((panel) => {
        let visible = 0;
        panel.querySelectorAll('[data-finder-model]').forEach((model) => {
          const match = query ? searchable(model.dataset.label).includes(query) : panel.dataset.finderPanel === brand;
          model.hidden = !match;
          if (match) visible += 1;
        });
        panel.hidden = visible === 0;
        shown += visible;
      });
      if (query && all) all.open = true;
      /* Una marca sin más vendidos (Samsung) abre la lista completa: si no, no se vería ningún modelo. */
      if (!query && all && (!best || best.hidden)) all.open = true;
      const empty = root.querySelector('[data-finder-empty]');
      if (empty) empty.hidden = !query || shown > 0;
    };

    /* La funda, en el panel: el modelo pulsado arriba y cada tarjeta con el enlace de su funda para ese
       modelo; las fundas que no lo tienen no salen. Si el modelo no tiene Slim, en vez de tarjetas, el botón
       «Extreme» a la Extreme con ese modelo. El foco va al modelo (lo que se acaba de elegir). */
    const openChoice = (link, dests, extremeUrl) => {
      opener = link;
      choose.querySelector('[data-finder-picked]').textContent = link.dataset.label;
      choose.querySelectorAll('[data-finder-case]').forEach((item, i) => {
        item.hidden = Boolean(extremeUrl) || !dests[i];
        if (!item.hidden) item.querySelector('a').href = dests[i];
      });
      choose.querySelector('.finder__cases').hidden = Boolean(extremeUrl);
      const next = choose.querySelector('[data-finder-extreme-link]');
      next.hidden = !extremeUrl;
      if (extremeUrl) next.href = extremeUrl;
      root.classList.add('is-choosing');
      choose.hidden = false;
      choose.querySelector('[data-finder-back]').focus({ preventScroll: true });
      choose.scrollIntoView({ block: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    const closeChoice = () => {
      choose.hidden = true;
      root.classList.remove('is-choosing');
      opener?.focus();
    };

    if (choose) {
      /* Sus fotos, cuando la página ya ha cargado (ocultas y lazy no bajarían hasta abrirlo): al elegir un
         modelo salen al momento, sin frenar la carga. */
      const preload = () => choose.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if (document.readyState === 'complete') preload();
      else window.addEventListener('load', preload, { once: true });
      choose.querySelector('[data-finder-back]').addEventListener('click', closeChoice);
      choose.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeChoice();
      });
    }

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-finder-brand]');
      if (button) {
        brand = button.dataset.finderBrand;
        search.value = '';
        render();
        return;
      }
      const model = event.target.closest('[data-finder-model]');
      if (!model) return;
      if (root.dataset.finderMode === 'filter') {
        event.preventDefault();
        root.dispatchEvent(new CustomEvent('finder:pick', { bubbles: true, detail: { model: model.dataset.finderModel } }));
        return;
      }
      /* Una sola funda (que no sea un modelo sin Slim), o abrir en otra pestaña: el enlace va directo a la ficha. */
      const extremeUrl = extreme[model.dataset.finderModel];
      if (!choose || (!model.dataset.finderDests && !extremeUrl) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openChoice(model, (model.dataset.finderDests || '').split('|'), extremeUrl);
    });
    search.addEventListener('input', render);
    /* En las colecciones, en móvil, la lista completa empieza plegada: si no, entierra las tarjetas. */
    if (root.dataset.finderMode === 'filter' && all && window.matchMedia('(max-width: 989px)').matches) all.open = false;
    render();
  });
})();
